// Imports for external libraries go here.
import React, { FC, useCallback } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { ConsentCheckListItemProps } from './ConsentCheckListItem.types';
import { StyledConsentCheckListItem } from './ConsentCheckListItem.styles';
import { CheckBox, Link } from '@marriott/mi-ui-library';
import { LegalTextWithLink } from '../LegalTextWithLink';

export const ConsentCheckListItem: FC<ConsentCheckListItemProps> = props => {
  const {
    label,
    errorLabel,
    termsBtnLabel,
    termsLink,
    selectedConsentId,
    id,
    checkboxLabelContainerClassName,
    checkboxContainerClassName,
    className,
    name,
    isChecked,
    onModalOpen,
    onChange,
    onLinkClickInCheckbox,
    linkClass,
    linkTarget,
    errorMessageClassName,
    validateErrors,
    showCheckbox,
  } = props;

  const showError = validateErrors && !isChecked;

  const onCheckboxChange = () => {
    onChange(selectedConsentId, id);
  };

  const onTermsModalOpen = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onModalOpen(e, termsLink!);
    },
    [termsLink, onModalOpen] // Dependencies to ensure function isn't recreated unnecessarily
  );

  return (
    <StyledConsentCheckListItem
      onClick={onLinkClickInCheckbox} // Attach click handler to all the anchor tags present within the checkbox label
      data-testid="legal-ConsentCheckListItem"
      data-component-name="m-legal-ConsentCheckListItem"
      className={checkboxContainerClassName ?? ''}
    >
      {showCheckbox ? (
        <CheckBox
          checkboxId={id}
          checkboxName={name}
          className={className ? className : ''}
          checked={isChecked}
          onChange={onCheckboxChange}
        >
          <LegalTextWithLink descriptionText={label} className={checkboxLabelContainerClassName || ''} />
          {showError && errorLabel && (
            <LegalTextWithLink descriptionText={errorLabel} className={errorMessageClassName} />
          )}
        </CheckBox>
      ) : (
        <>
          <LegalTextWithLink descriptionText={label} className={checkboxLabelContainerClassName || ''} />
          {showError && errorLabel && (
            <LegalTextWithLink descriptionText={errorLabel} className={errorMessageClassName} />
          )}
        </>
      )}
      {termsLink && termsBtnLabel && (
        <Link
          linkHref={termsLink}
          linkClassName={linkClass ? linkClass : ''}
          target={linkTarget}
          text={termsBtnLabel}
          callback={onTermsModalOpen}
        />
      )}
    </StyledConsentCheckListItem>
  );
};
